<template xmlns="http://www.w3.org/1999/html">
    <el-container>
        <el-header style="height: 30px">
            <van-nav-bar title="结账单" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main>
            <el-form :inline="true" :model="searchParms">
                <el-form-item label="品牌门店">
                    <el-cascader :options="storeData" clearable filterable v-model="searchParms.storeStructs" :props="{ checkStrictly: true }"
                                 size="mini" style="width: 100%" @change="storeChange"></el-cascader>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="searchParms.finished" :true-label="1" :false-label="0" @change="btnquery">完成</el-checkbox>
                </el-form-item>
            </el-form>
            <div v-for="(item,index) in checkOutData" :key="index" v-infinite-scroll="loadmore">
                <el-descriptions direction="vertical" :column="11" border v-if="item.mthamount>0" style="margin-bottom: 20px">
                    <template slot="extra">
                        <el-button type="primary" size="small" @click="openUpdate(item)">修改</el-button>
                        <el-button type="danger" size="small" :loading="queryLoadBtton" @click="inteboCheckOutFinished(item)">结账</el-button>
                    </template>
                    <el-descriptions-item label="日期">{{$moment(item.fromdate).format('MM.DD')}}-{{$moment(item.todate).format('MM.DD')}}</el-descriptions-item>
                    <el-descriptions-item label="企业名称">{{item.storename}}</el-descriptions-item>
                    <el-descriptions-item label="门店业绩"><span style="color: red">{{item.perf}}</span></el-descriptions-item>
                    <el-descriptions-item :label="item.title">
                        <span style="color: red">{{item.backamount}}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="本月月供"><span style="color: red">{{Math.round(item.mthamount)}}</span></el-descriptions-item>
                    <el-descriptions-item label="仪器总额"><span style="color: red">{{item.yqamount}}</span></el-descriptions-item>
                    <el-descriptions-item label="已收款"><span style="color: red">{{Math.round(item.realamount)}}</span></el-descriptions-item>
                    <el-descriptions-item label="剩余款项金"><span style="color: red">{{Math.round(item.restamount)}}</span></el-descriptions-item>
                    <el-descriptions-item :label="'剩余分'+item.restfq+'期金额'" v-show="Math.round(item.mthamount)>0"><span style="color: red">{{Math.round(item.mthamount)}}</span></el-descriptions-item>
                    <el-descriptions-item label="是否到账">
                        <span style="color: red" v-if="item.finished==1">已结账</span>
                        <span style="color: #409eff" v-if="item.finished==0">未结账</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="负责总监">{{item.header}}</el-descriptions-item>
                    <el-descriptions-item label="回款信息">
                        {{item.storename}}:本次应打回款:<span style="color: red">{{Math.round(item.backamount)}}+{{Math.round(item.mthamount)}}={{Math.round(item.backamount)+Math.round(item.mthamount)}}</span>
                        剩余仪器款:<span style="color: red">{{Math.round(item.restamount)}}</span>元，剩余{{item.restfq}}期分期金额:<span style="color: red">{{Math.round(item.mthamount)}}</span>
                    </el-descriptions-item>
                </el-descriptions>

                <el-descriptions direction="vertical" :column="9" border v-if="item.mthamount<1">
                    <template slot="extra">
                        <el-button type="primary" size="small" @click="openUpdate(item)">修改</el-button>
                        <el-button type="danger" size="small" :loading="queryLoadBtton" @click="inteboCheckOutFinished(item)">结账</el-button>
                    </template>
                    <el-descriptions-item label="日期">{{$moment(item.fromdate).format('MM.DD')}}-{{$moment(item.todate).format('MM.DD')}}</el-descriptions-item>
                    <el-descriptions-item label="企业名称">{{item.storename}}</el-descriptions-item>
                    <el-descriptions-item label="门店业绩"><span style="color: red">{{item.perf}}</span></el-descriptions-item>
                    <el-descriptions-item :label="item.title">
                        <span style="color: red">{{item.backamount}}</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="仪器总额"><span style="color: red">{{item.yqamount}}</span></el-descriptions-item>
                    <el-descriptions-item label="已收款"><span style="color: red">{{Math.round(item.realamount)}}</span></el-descriptions-item>
                    <el-descriptions-item label="剩余款项金"><span style="color: red">{{Math.round(item.restamount)}}</span></el-descriptions-item>
                    <el-descriptions-item label="是否到账">
                        <span style="color: red" v-if="item.finished==1">已结账</span>
                        <span style="color: #409eff" v-if="item.finished==0">未结账</span>
                    </el-descriptions-item>
                    <el-descriptions-item label="负责总监">{{item.header}}</el-descriptions-item>
                    <el-descriptions-item label="回款信息">
                        {{item.storename}}:本次应打回款:<span style="color: red">{{Math.round(item.backamount)}}</span>
                        剩余仪器款:<span style="color: red">{{Math.round(item.restamount)}}</span>元.
                    </el-descriptions-item>
                </el-descriptions>
            </div>
        </el-main>
        <el-dialog title="修改结账单" :visible.sync="dialogVisible" width="100%" top="0px" @close="dialogVisible=false" class="checkclass"
                   :close-on-press-escape="false" :close-on-click-modal="false">
            <el-form :model="checkOut" label-width="100px">
                <el-form-item label="品牌门店">
                    {{checkOut.parentname}}/{{checkOut.storename}}
                </el-form-item>
                <el-form-item label="日期">
                    {{checkOut.fromdate}}到{{checkOut.todate}}
                </el-form-item>
                <el-form-item label="门店业绩">
                    {{checkOut.perf}}
                </el-form-item>
                <el-form-item :label="checkOut.title">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.backamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="本月月供">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.mthamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="仪器总额">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.yqamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="已收款">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.realamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="剩余款项金">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.restamount">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="剩余分期">
                    <el-input-number style="text-align: left;width: 100%" :precision="0" :controls="false" :min="0" size="mini" v-model="checkOut.restfq">
                    </el-input-number>
                </el-form-item>
                <el-form-item label="负责总监">
                    {{checkOut.header}}
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" :loading="queryLoadBtton" size="mini" @click="updateInteboCheckOut()">保存</el-button>
            </div>
        </el-dialog>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            queryLoadBtton:false,
            dialogVisible:false,
            searchParms:{
                storeStructs:[],
                parentid:"",
                storeid:"",
                finished:0,
            },
            storeData:[],
            curpage:1,
            pagesize:20,
            isFinite:false,
            checkOutData:[],
            checkOut:{},
        }
    },
    created() {
        this.getInteboStoreStructs();
        this.btnquery();
    },
    methods:{
        inteboCheckOutFinished(item){
            this.$dialog.confirm({
                title: "提示",
                message: "你确定该结账单是否正确吗？"
            }).then(() => {
                this.queryLoadBtton=true;
                this.$postw("intebosale/inteboCheckOutFinished",item).then(res=>{
                    this.queryLoadBtton=false;
                    if(res.sucess){
                        this.dialogVisible=false;
                        this.queryLoadBtton=false;
                        this.$message({message: "保存成功", type: 'success'});
                    }
                });
            });
        },
        updateInteboCheckOut(){
            this.queryLoadBtton=true;
            let totalamount=this.$addNumber(this.checkOut.backamount,this.checkOut.mthamount);
            totalamount=this.$addNumber(this.checkOut.restamount,totalamount);
            if(totalamount!=this.checkOut.qyamount){
                this.$message({message: "支付金额+剩余金额不等于仪器总金额", type: 'error'});
                this.queryLoadBtton=false;
                return;
            }
            this.$postw("intebosale/updateInteboCheckOut",this.checkOut).then(res=>{
                this.queryLoadBtton=false;
                if(res.sucess){
                    this.dialogVisible=false;
                    this.$message({message: "保存成功", type: 'success'});
                }
            });
        },
        openUpdate(item){
            this.checkOut=item;
            this.dialogVisible=true;
        },
        getSummaries(param){
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column,index)=>{
                if(index==0) {
                    column.colSpan = columns.length;
                    column.rowSpan = 1;
                    sums[index]=<div></div>;
                }
            });
            setTimeout( ()=> {
                this.$nextTick(function (){
                    //let div=this.$refs["check"+data[0].id];
                    let div=document.getElementById("check"+data[0].id);
                    console.log(div);
                    div.innerHTML="1";
                });
            },500);
            return sums;
        },
        btnquery(){
            this.isFinite=false;
            this.checkOutData=[];
            this.curpage=1;
            this.getInteboCheckOutByFinished();
        },
        loadmore(){
            if(this.isFinite==false){
                this.curpage++;
                this.getInteboCheckOutByFinished();
            }
        },
        getInteboCheckOutByFinished(){
            this.$post("intebosale/getInteboCheckOutByFinished",{parentid:this.searchParms.parentid,storeid:this.searchParms.storeid,
                curpage:this.curpage,pagesize:this.pagesize,finished: this.searchParms.finished}).then(res=>{
                if(res.sucess){
                    let obj=res.object;
                    if(obj!=null && obj.length>0){
                        for(let val of obj){
                            this.checkOutData.push(val);
                        }
                    }
                    else{
                        this.isFinite=true;
                    }
                }
            });
        },
        storeChange(val){
            this.searchParms.parentid="";
            this.searchParms.storeid="";
            if(val[0]){
                this.searchParms.parentid=val[0];
            }
            if(val[1]){
                this.searchParms.storeid=val[1];
            }
            this.isFinite=false;
            this.checkOutData=[];
            this.curpage=1;
            this.getInteboCheckOutByFinished();
        },
        getInteboStoreStructs(){
            this.$post("inteboStore/getInteboStoreStructs").then(res=>{
                if(res.sucess){
                    this.storeData=res.object;
                }
            });
        }
    }
}
</script>
<style style lang="scss" rel="stylesheet/scss">
    .checkclass .el-input-number .el-input__inner{
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/page/intebo/intebotab/intebocheckout.vue